// German for the deck editor (Decks tab). Registered on load. Deck vocabulary follows the
// register glossary: deliverable → Arbeitsergebnis, slide → Folie, slot → Slot (the frozen
// design's own term). Document text INSIDE the previews is frozen German and never comes
// through here — this catalogue covers the operator UI only.
import { registerDe } from '../../i18n/index.js';

registerDe({
  'The image starts here; the text column ends 36 px before it.': 'Hier beginnt das Bild; die Textspalte endet 36 px davor.',
  'Remove this image from the picker': 'Dieses Bild aus der Auswahl entfernen',
  'The image could not be restored.': 'Das Bild konnte nicht wiederhergestellt werden.',
  '{n} hidden': '{n} ausgeblendet',
  'Drag to move · zoom': 'Ziehen zum Verschieben · Zoom',
  'Reset': 'Zurücksetzen',
  'Split: text + image': 'Split: Text + Bild',
  'Split position': 'Split-Position',
  'Image side': 'Bildseite',
  'right': 'rechts',
  'left': 'links',
  'Focal point x': 'Fokus x',
  'Focal point y': 'Fokus y',
  'Zoom': 'Zoom',
  'Remove slide': 'Folie entfernen',
  'Add after this slide': 'Nach dieser Folie einfügen',
  'Remove': 'Entfernen',
  'Remove «{name}» from this deck? Its slot texts are lost; the register data stays.': '«{name}» aus diesem Deck entfernen? Die Slot-Texte gehen verloren, die Registerdaten bleiben.',
  'Delete this image': 'Dieses Bild löschen',
  'Upload an image (PNG or JPEG)': 'Bild hochladen (PNG oder JPEG)',
  'The image could not be uploaded.': 'Das Bild konnte nicht hochgeladen werden.',
  'The image could not be deleted.': 'Das Bild konnte nicht gelöscht werden.',
  'Starting point': 'Ausgangslage',
  'Section divider': 'Trennseite',
  'Annex deliverable register': 'Anhang Arbeitsergebnisregister',
  'First paragraph': 'Erster Absatz',
  'Second paragraph': 'Zweiter Absatz',
  'Third paragraph': 'Dritter Absatz',
  'Phase axis': 'Phasenachse',
  'Result cards': 'Ergebniskarten',
  'Terminal milestones': 'Meilensteine der Schlusskarte',
  'Date markers': 'Terminmarker',
  'Short name override': 'Kurzname (Override)',
  'Due-date note': 'Terminhinweis',
  'Tagline': 'Tagline',
  // ── page / list ────────────────────────────────────────────────────────────
  'Decks': 'Decks',
  'No engagement selected': 'Kein Auftrag ausgewählt',
  'Decks belong to one engagement — pick an engagement to see its proposal decks.':
    'Decks gehören zu einem Auftrag — wähle einen Auftrag, um seine Angebots-Decks zu sehen.',
  'New deck': 'Neues Deck',
  'Deck title': 'Deck-Titel',
  'e.g. “Vorprojekt — Projektplan & Angebot”': 'z. B. «Vorprojekt — Projektplan & Angebot»',
  'Create': 'Erstellen',
  'A new deck starts with the standard 13-slide order — every slide can be toggled off in the editor.':
    'Ein neues Deck startet mit der Standard-Reihenfolge aus 13 Folien — jede Folie lässt sich im Editor einzeln abschalten.',
  'Could not load the decks': 'Decks konnten nicht geladen werden',
  'No decks yet': 'Noch keine Decks',
  'A deck is this engagement’s proposal document — slides bound live to the register.':
    'Ein Deck ist das Angebotsdokument dieses Auftrags — die Folien sind live an das Register gebunden.',
  'The deck could not be created.': 'Das Deck konnte nicht erstellt werden.',
  'final': 'final',
  'archived': 'archiviert',

  // ── editor masthead ────────────────────────────────────────────────────────
  '{n} slides': '{n} Folien',
  'Back to decks': 'Zurück zu den Decks',
  'Export PPTX': 'PPTX exportieren',
  'Download v{n}': 'v{n} herunterladen',
  'Version v{n} exported': 'Version v{n} exportiert',
  'The export failed — nothing was written.': 'Der Export ist fehlgeschlagen — nichts wurde geschrieben.',
  'Could not load the deck': 'Das Deck konnte nicht geladen werden',
  'The slide could not be saved.': 'Die Folie konnte nicht gespeichert werden.',
  'No slides in this deck': 'Keine Folien in diesem Deck',
  'A deck is created with the standard 13-slide order — this one has none.':
    'Ein Deck wird mit der Standard-Reihenfolge aus 13 Folien angelegt — dieses hat keine.',

  // ── rail / stage ───────────────────────────────────────────────────────────
  'Move up': 'Nach oben',
  'Move down': 'Nach unten',
  'Included': 'Enthalten',
  'This slide paginates into {n} pages from the register data.':
    'Diese Folie paginiert aus den Registerdaten in {n} Seiten.',

  // ── slot panel ─────────────────────────────────────────────────────────────
  'Slots': 'Slots',
  'Over budget — not saved. Shorten the marked slots.':
    'Über Budget — nicht gespeichert. Kürze die markierten Slots.',
  'One entry per line': 'Ein Eintrag pro Zeile',
  'No image': 'Kein Bild',
  'Add entry': 'Eintrag hinzufügen',
  'Refs, comma-separated — e.g. REQ-050': 'Refs, kommagetrennt — z. B. REQ-050',
  'No mandate references in the library yet.': 'Noch keine Mandats-Referenzen in der Bibliothek.',

  // the register-bound block
  'From the register': 'Aus dem Register',
  'This block is filled live from the register — edit deliverables, requirements and dates there.':
    'Dieser Block wird live aus dem Register gefüllt — Arbeitsergebnisse, Anforderungen und Termine werden dort bearbeitet.',
  '{n} deliverables on the time track': '{n} Arbeitsergebnisse auf der Zeitachse',
  '{n} deliverables across {p} pages': '{n} Arbeitsergebnisse auf {p} Seiten',
  '{r} requirements · {d} deliverables · {e} edges': '{r} Anforderungen · {d} Arbeitsergebnisse · {e} Kanten',
  '{n} reference cards selected': '{n} Referenzkarten ausgewählt',
  '{n} people from the library': '{n} Personen aus der Bibliothek',
  '{n} requirements across {p} pages': '{n} Anforderungen auf {p} Seiten',
  'Loading register data …': 'Registerdaten werden geladen …',
  'No register data yet for this slide.': 'Noch keine Registerdaten für diese Folie.',

  // ── slide type names (catalogue) ───────────────────────────────────────────
  'Cover': 'Titelfolie',
  'Mandate (split)': 'Auftrag (Split)',
  'Target picture & timeline': 'Zielbild & Zeitachse',
  'Work packages (Gantt)': 'Arbeitspakete (Gantt)',
  'Deliverables table': 'Arbeitsergebnis-Tabelle',
  'Traceability mesh': 'Traceability-Mesh',
  'Reference cards': 'Referenzkarten',
  'Team': 'Team',
  'Investment': 'Investition',
  'Next steps (split)': 'Nächste Schritte (Split)',
  'Annex divider': 'Anhang-Trenner',
  'Annex register': 'Anhang-Register',
  'Back cover': 'Rückseite',

  // ── slot labels (catalogue) ────────────────────────────────────────────────
  'Eyebrow': 'Eyebrow',
  'Title': 'Titel',
  'Subtitle': 'Untertitel',
  'Client name': 'Kundenname',
  'Date label': 'Datumszeile',
  'Hero image': 'Hero-Bild',
  'Body': 'Fliesstext',
  'Image': 'Bild',
  'Intro': 'Einleitung',
  'Timeline items': 'Zeitachsen-Stationen',
  'Terminal note': 'Schlusszeile',
  'Phase legend': 'Phasen-Legende',
  'Acceptance summary override': 'Abnahmekriterien-Kurzform (Override)',
  'Subtitle override': 'Untertitel (Override)',
  'Footer note': 'Fusszeile',
  'Claims': 'Claims',
  'Highlighted requirements': 'Hervorgehobene Anforderungen',
  'Legend': 'Legende',
  'References': 'Referenzen',
  'Takeaway override': 'Takeaway (Override)',
  'Footer line': 'Schlusszeile (Serif)',
  'Third parties': 'Drittparteien',
  'People': 'Personen',
  'Months': 'Monate',
  'Days per month': 'Tage pro Monat',
  'Utilisation %': 'Auslastung %',
  'Day rate (CHF)': 'Tagessatz (CHF)',
  'Discounts': 'Rabatte',
  'Budget label': 'Budget-Zeile',
  'Steps': 'Schritte',
  'Footer': 'Fusszeile (mono)',
  'Label': 'Bezeichnung',
  'Contact lines': 'Kontaktzeilen',
  'Note': 'Notiz',
  'Page titles': 'Seitentitel',
  'Descoped note': 'Descoped-Fusszeile',

  // item field labels
  'Name': 'Name',
  'Person': 'Person',
  'Profile context': 'Profil-Kontext',
  'Percent': 'Prozent',
  'Category': 'Kategorie',
}, 'DecksPage');
